import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import SiteLayout from '@/layouts/SiteLayout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: SiteLayout,
    children: [
      { path: '', name: 'home', component: () => import('@/views/home/index.vue') },
      { path: 'login', name: 'login', component: () => import('@/views/login/index.vue') },
      { path: 'articles', name: 'articles', component: () => import('@/views/article/list.vue') },
      { path: 'articles/:id', name: 'article-detail', component: () => import('@/views/article/detail.vue') },
      { path: 'demands', name: 'demands', component: () => import('@/views/demand/list.vue') },
      { path: 'demands/:id', name: 'demand-detail', component: () => import('@/views/demand/detail.vue') },
      { path: 'members', name: 'members', component: () => import('@/views/member/list.vue') },
      { path: 'members/:id', name: 'member-detail', component: () => import('@/views/member/detail.vue') },
      { path: 'activities', name: 'activities', component: () => import('@/views/activity/list.vue') },
      { path: 'activities/:id', name: 'activity-detail', component: () => import('@/views/activity/detail.vue') },
      { path: 'activities/:id/signup', name: 'activity-signup', component: () => import('@/views/activity/signup.vue') },
      {
        path: 'account',
        component: () => import('@/layouts/AccountLayout.vue'),
        meta: { auth: true },
        redirect: '/account/profile',
        children: [
          { path: 'profile', name: 'account-profile', component: () => import('@/views/account/profile.vue') },
          { path: 'demands', name: 'account-demands', component: () => import('@/views/account/demands.vue') },
          { path: 'demands/publish', name: 'account-publish', component: () => import('@/views/account/publish.vue') },
          { path: 'activities', name: 'my-activities', component: () => import('@/views/account/activities.vue') },
          { path: 'messages', name: 'account-messages', component: () => import('@/views/account/messages.vue') },
          { path: 'exchanges', name: 'account-exchanges', component: () => import('@/views/account/exchanges.vue') },
          { path: 'favorites', name: 'account-favorites', component: () => import('@/views/account/favorites.vue') },
          { path: 'chat', name: 'account-chat', component: () => import('@/views/account/chat.vue') },
          { path: 'vip', name: 'account-vip', component: () => import('@/views/vip/index.vue') },
          { path: 'settings', name: 'account-settings', component: () => import('@/views/account/settings.vue') }
        ]
      },
      { path: 'circle', name: 'circle', component: () => import('@/views/circle/index.vue') },
      { path: 'expo', name: 'expo', component: () => import('@/views/expo/index.vue') },
      { path: 'about', name: 'about', component: () => import('@/views/about/index.vue') },
      { path: 'cooperate', name: 'cooperate', component: () => import('@/views/cooperate/index.vue') },
      { path: 'legal/:type', name: 'legal', component: () => import('@/views/legal/index.vue') },
      { path: 'search', name: 'search', component: () => import('@/views/search/index.vue') },
      { path: 'vip', name: 'vip', component: () => import('@/views/vip/index.vue') },
      { path: 'detail/:id', name: 'old-detail', component: () => import('@/views/redirect/resolve.vue') },
      { path: 'detail/*', name: 'old-detail-fallback', component: () => import('@/views/redirect/resolve.vue') },
      { path: '*', name: 'not-found', component: () => import('@/views/error/not-found.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(r => r.meta && r.meta.auth) && !store.getters.isLogin) {
    next({ path: '/login', query: { redirect: to.fullPath } })
    return
  }
  next()
})

export default router
